import { render, staticRenderFns } from "./SongwriterContracts.vue?vue&type=template&id=3da63cb6"
import script from "./SongwriterContracts.vue?vue&type=script&lang=js"
export * from "./SongwriterContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports